import Icon from '../components/Icon.vue'

Icon.register({
  info: {
    width: 192,
    height: 512,
    paths: [
      {
        d: 'M20 424.2H40V279.8H20C9 279.8 0 270.8 0 259.8V212C0 201 9 192 20 192H132C143 192 152 201 152 212V424.2H172C183 424.2 192 433.2 192 444.2V492C192 503 183 512 172 512H20C9 512 0 503 0 492V444.2C0 433.2 9 424.2 20 424.2zM96 0C56.2 0 24 32.2 24 72S56.2 144 96 144 168 111.8 168 72 135.8 0 96 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/info.js
// module id = jpe6
// module chunks = 144